import { render, staticRenderFns } from "./boxCorner.vue?vue&type=template&id=2b669882"
import script from "./boxCorner.vue?vue&type=script&lang=js"
export * from "./boxCorner.vue?vue&type=script&lang=js"
import style0 from "./boxCorner.vue?vue&type=style&index=0&id=2b669882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports